// 生产管理-生产列表-箱格配置信息
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea BoxConfig">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <div class="deviceInfo" v-if="deviceBoxList.info">
      <div class="text">设备ID: {{ deviceBoxList.info.device_no_id }}</div>
      <div class="text">
        设备类型: {{ deviceBoxList.info.device_type_name }}
      </div>
      <div class="text">
        代理商名称: {{ deviceBoxList.info.device_company_name }}
      </div>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent" v-if="deviceBoxList.info">
      <!-- 添加按钮 -->
      <el-button class="addBtn" @click="operateDialogInfo('cabinets')"
        >添 加</el-button
      >

      <!-- 柜类列表 -->
      <el-table
        class="cabinetsList"
        :data="cabinetTableData"
        style="width: 60%"
        :cell-style="setCellStyle"
        :header-cell-style="setCellStyle"
        border
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="box_number" label="编号" sortable> </el-table-column>
        <el-table-column label="类型">
          {{ deviceBoxList.info.device_type_name }}
        </el-table-column>
        <el-table-column prop="box_size" label="大小" sortable> </el-table-column>
        <el-table-column prop="status_text" label="箱格状态" sortable> </el-table-column>
        <el-table-column prop="open_status_text" label="锁状态" sortable>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-popconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定删除该箱格吗？"
              @onConfirm="onDeleteBox(scope.row)"
            >
              <el-button
                slot="reference"
                type="text"
                >删除</el-button
              >
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status == 2"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定启用该箱格吗？"
              @onConfirm="onUpdateBoxStatus(scope.row)"
            >
              <el-button
                slot="reference"
                type="text"
                >启用</el-button
              >
            </el-popconfirm>
            
            <el-popconfirm
              v-else
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确定禁用该箱格吗？"
              @onConfirm="onUpdateBoxStatus(scope.row)"
            >
               <el-button
                slot="reference"
                type="text"
                >禁用</el-button
              >
            </el-popconfirm>
     
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--对话框-->
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.visible"
      :show-close="dialogData.title === '' ? false : true"
    >
      <!-- 柜类添加信息 -->
      <div v-if="dialogData.type === 'cabinets'">
        <el-form label-width="100px">
          <el-form-item label="类型:">
            <div class="inputBox clearfix">
              <el-input
                class="inputDeposit"
                v-model="dialogData.info.device_type_name"
                readonly
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="箱格数量:">
            <div class="inputBox clearfix">
              <el-input
                class="inputDeposit number"
                v-model="dialogData.info.number"
              ></el-input>
              个
            </div>
          </el-form-item>
          <el-form-item
            v-for="(item, index) in dialogData.info.box"
            :key="item.box_type"
            :label="item.box_name"
            @click="clickFormItem(index)"
          >
            <div class="inputBox clearfix">
              <el-input class="inputSmall" v-model="item.number"></el-input>
              <span class="unit">个</span>
              <el-input
                class="inputSmall"
                placeholder="开始编号"
                v-model="item.minNo"
                @input="minInputChange"
                @blur="minInputBlur"
              ></el-input>
              <span class="symbol">~</span>
              <el-input
                class="inputSmall"
                placeholder="结束编号"
                v-model="item.maxNo"
                @input="maxInputChange"
                @blur="maxInputBlur"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmCabinet()">确 认</el-button>
        </div>
      </div>

      <!-- 删除 -->
      <div
        class="changeStatusWrapper"
        v-else-if="dialogData.type === 'cabinetsDelete'"
      >
        <!-- 批量删除 -->
        <p class="text">
          确认删除所选信息？
        </p>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogData.visible = false">否</el-button>
          <!-- 删除id -->
          <el-button @click="deleteBox">是</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "../../../Layout/BreadCrumb.vue";
import {
  showToast,
  isRepeat
} from "../../../../../static/js/utility/utility.js";
import { getNowDate } from "../../../../../static/js/utility/date.js";
import {
  systemApi,
  deviceApi,
  maintainApi
} from "../../../../../static/js/api.js";
import store from "../../../../store";
let vm;

export default {
  name: "BoxConfig",
  components: {
    BreadCrumb
  },

  data() {
    return {
      // 对话框数据
      dialogData: {
        type: "",
        title: "",
        visible: false,
        info: {}
      },

      deviceBoxList: {},

      // 待新增的箱格列表
      addBoxData: {
        number: "",
        box: []
      },

      // 已添加的箱格列表
      cabinetTableData: [],

      boxActiveIndex: 0,
      isConfirm: true,
      noArr: []
    };
  },

  created() {
    vm = this;
  },

  mounted() {
    vm.getDeviceBoxList();
  },

  methods: {
    // 操作对话框信息（添加或修改）dialogData
    operateDialogInfo: function(type, info) {
      console.log("type", type);
      let device_type_name = vm.deviceBoxList.info.device_type_name;
      // 柜类添加信息
      let cabinetInfo = {
        device_type_name: device_type_name,
        number: "",
        box: [
          {
            box_name: "A(极大):",
            box_size: "A",
            number: "",
            maxNo: "",
            minNo: ""
          },

          {
            box_name: "B(大):",
            box_size: "B",
            number: "",
            maxNo: "",
            minNo: ""
          },

          {
            box_name: "C(中):",
            box_size: "C",
            number: "",
            maxNo: "",
            minNo: ""
          },

          {
            box_name: "D(小):",
            box_size: "D",
            number: "",
            maxNo: "",
            minNo: ""
          },

          {
            box_name: "E(极小):",
            box_size: "E",
            number: "",
            maxNo: "",
            minNo: ""
          }
        ]
      };

      vm.dialogData = {
        type: type,
        title: type === "cabinets" ? "添加" : "",
        visible: !vm.dialogData.visible,
        info: type === "cabinets" ? cabinetInfo : info
      };
      // console.log('vm', vm.dialogData)
    },

    // 获取设备箱格配置信息
    async getDeviceBoxList() {
      let data = { device_no_id: vm.$route.query.device_no_id };
      let res = await deviceApi.getDeviceBoxList(data);
      if (res.meta.code === 200) {
        console.log("res", res);
        vm.deviceBoxList = res.data;
        vm.cabinetTableData = res.data.list;
      } else {
        showToast(res.meta.message);
      }
    },

    // 设置单元格样式(表头和序号那一列)
    setCellStyle: function({ row, column, rowIndex, columnIndex }) {
      // console.log('row', row)
      // console.log('column', column)
      // console.log('rowIndex', rowIndex)
      // console.log('columnIndex', columnIndex)
      if ((!row.box_number && rowIndex === 0) || columnIndex === 0) {
        return { backgroundColor: "#F5F7FA" };
      } else {
        return {};
      }
    },

    clickFormItem(index) {
      console.log("index", index);
    },

    // 柜类input输入框值变化
    minInputChange(val) {
      console.log("val", val);
      vm.dialogData.info.box.forEach((item, index) => {
        if (item.minNo == val) {
          console.log("index::", index);
          vm.boxActiveIndex = index;
        }
      });
    },

    minInputBlur() {
      let maxval = vm.dialogData.info.box[vm.boxActiveIndex].maxNo;
      let minval = vm.dialogData.info.box[vm.boxActiveIndex].minNo;
      let number = vm.dialogData.info.box[vm.boxActiveIndex].number;
      vm.isConfirm = true;
      console.log(
        maxval - minval + 1,
        "maxval",
        maxval,
        "minval",
        minval,
        "number",
        number
      );
      if (maxval - minval + 1 != number && maxval != "") {
        showToast("箱格编号范围与分配数量不符");
        vm.isConfirm = false;
        vm.dialogData.info.box[vm.boxActiveIndex].minNo = "";
        return;
      }
      vm.cabinetTableData.forEach(function(item, index) {
        if (item.box_number == minval) {
          showToast(minval + "号箱格已添加，请重新输入");
          vm.dialogData.info.box[vm.boxActiveIndex].minNo = "";
          return;
        }
      });
      // vm.noArr.forEach(function (item, index) {
      //   if (item == minval) {
      //     showToast(minval + '号箱格已存在，请重新输入')
      //     vm.dialogData.info.box[vm.boxActiveIndex].minNo = ''
      //     return
      //   }
      // })
    },

    maxInputChange(val) {
      console.log("val", val);
      vm.dialogData.info.box.forEach((item, index) => {
        if (item.maxNo == val) {
          console.log("index::", index);
          vm.boxActiveIndex = index;
        }
      });
    },

    maxInputBlur() {
      let maxval = vm.dialogData.info.box[vm.boxActiveIndex].maxNo;
      let minval = vm.dialogData.info.box[vm.boxActiveIndex].minNo;
      let number = vm.dialogData.info.box[vm.boxActiveIndex].number;
      vm.isConfirm = true;
      console.log(
        maxval - minval + 1,
        "maxval",
        maxval,
        "minval",
        minval,
        "number",
        number
      );
      if (maxval - minval + 1 != number && minval != "") {
        showToast("箱格编号范围与分配数量不符");
        vm.isConfirm = false;
        vm.dialogData.info.box[vm.boxActiveIndex].maxNo = "";
        return;
      }
      vm.cabinetTableData.forEach(function(item, index) {
        if (item.box_number == maxval) {
          showToast(maxval + "号箱格已添加，请重新输入");
          vm.dialogData.info.box[vm.boxActiveIndex].maxNo = "";
          return;
        }
      });
      console.log("noArr", vm.noArr);
    },

    /* 柜类相关操作 */
    // 柜类确认添加信息
    confirmCabinet: function() {
      let box = vm.dialogData.info.box;
      let boxSum = 0;
      // 获取dialog要生成的箱格数量
      for (let i in box) {
        // 当有箱格数量时
        let number = box[i].number === "" ? 0 : parseInt(box[i].number);
        boxSum = boxSum + number;
      }
      // 箱格数量不符
      if (boxSum !== parseInt(vm.dialogData.info.number)) {
        showToast("分配的箱格数是" + (boxSum === "" ? "0" : boxSum) + "个");
        return;
      }

      // 获取添加箱格数据
      vm.addBoxData.number = parseInt(vm.dialogData.info.number);
      vm.addBoxData.box = [];
      for (let i in box) {
        // 当有箱格数量时
        let number = box[i].number === "" ? 0 : parseInt(box[i].number);

        // 获取箱格信息列表
        if (number !== 0) {
          let minNo = box[i].minNo;
          let maxNo = box[i].maxNo;
          if (minNo === "") {
            showToast("请设置" + box[i].box_size + "的开始编号！");
            return;
          }
          if (isNaN(parseInt(minNo)) || isNaN(parseInt(maxNo))) {
            showToast("编号只能为数字");
            return;
          }
          for (let j = 0; j < number; j++) {
            vm.addBoxData.box.push({
              box_number: minNo++,
              // type: vm.dialogData.info.device_type_name,
              box_size: box[i].box_size
            });
          }
        }
      }

      if (!vm.isConfirm) {
        return;
      }
      vm.saveCabinetInfo();
    },

    // 保存，确认柜类出库
    saveCabinetInfo: function() {
      let newNotAddList = [...vm.cabinetTableData];
      vm.addBoxData.box.forEach((item, i) => {
        newNotAddList.push({
          box_size: item.box_size,
          box_number: item.box_number
        });
      });
      // console.log('vm.cabinetTableData', vm.cabinetTableData)
      // console.log('newNotAddList', newNotAddList)

      // 判断
      if (isRepeat(newNotAddList, "box_number")) {
        showToast("不能有相同的编号！");
        return;
      }

      // 添加箱格
      vm.addBox();
    },

    // 添加箱格
    async addBox() {
      let data = vm.addBoxData;
      data.device_no_id = vm.$route.query.device_no_id;
      data.device_id = vm.deviceBoxList.info.device_id;
      console.log("data", data);
      // return

      let res = await deviceApi.addCabinetBox(data);
      if (res.meta.code === 200) {
        showToast("添加成功");
        vm.dialogData.visible = false;
        vm.getDeviceBoxList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 删除箱格信息
    async deleteBox() {
      console.log("vm.dialogData.info", vm.dialogData.info);
      let data = {
        device_no_id: vm.$route.query.device_no_id,
        box_size: vm.dialogData.info.row.box_size,
        box_number: vm.dialogData.info.row.box_number
      };

      let res = await deviceApi.deleteCabinetBox(data);
      if (res.meta.code === 200) {
        showToast("删除成功");
        vm.dialogData.visible = false;
        vm.getDeviceBoxList();
      } else {
        showToast(res.meta.message);
      }
    },

    async onUpdateBoxStatus(box) {
      let deviceNoId = box.device_no_id;
      let boxNumber = box.box_number;
      let boxStatus = box.status;
      let updateBoxStatus;
      console.log(box)
      if (boxStatus == '2') {
        //由禁用更新为空闲
        updateBoxStatus = 0;
      } else {
        //由启用更新为禁用
        updateBoxStatus = 2;
      }
      
      let data = {
        device_no_id: deviceNoId,
        box_number: boxNumber,
        status: updateBoxStatus,
      };

      let res = await deviceApi.updateCabinetBox(data);
      if (res.meta.code === 200) {
        showToast("更新成功");
        vm.dialogData.visible = false;
        vm.getDeviceBoxList();
      } else {
        showToast(res.meta.message);
      }
    },

    // 删除箱格信息
    async onDeleteBox(box) {
      
      let data = {
        device_no_id: box.device_no_id,
        box_size: box.box_size,
        box_number: box.box_number
      };

      let res = await deviceApi.deleteCabinetBox(data);
      if (res.meta.code === 200) {
        showToast("删除成功");
        vm.dialogData.visible = false;
        vm.getDeviceBoxList();
      } else {
        showToast(res.meta.message);
      }
    },


  },

  watch: {}
};
</script>

<style lang="scss" scoped>
.BoxConfig {
  .deviceInfo {
    padding: 20px;
    margin: 24px 24px 0;
    background-color: #ffffff;
    display: flex;
    .text {
      &.text {
        margin-right: 40px;
      }
    }
  }
  .addBtn {
    margin-bottom: 20px;
  }
  .inputBox {
    width: 345px;
    .inputDeposit.number {
      width: 300px;
      float: left;
      margin-right: 20px;
    }
    .inputSmall {
      width: 90px;
      float: left;
    }
    .unit,
    .symbol {
      float: left;
      margin: 0 10px;
    }
    .unit {
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProductList/BoxConfig.vue